
import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbEvento extends AppService {
  abstract getEventos(): Observable<any>;
}